<template>
<v-app id="registration-page">
    <cookie-law theme="blood-orange--rounded" 
                  buttonText="ACCETTO!">
                  <div slot="message">
                    QuickBe Utilizza cookie tecnici e di terze parti per fornirti il migliore servizio possible, 
                    puoi vedere in dettaglio cosa usiamo e come disabilitarlo da qui:
                    <router-link class="q-orange"
                      :title="getString('Uso dei cookies')"
                      to="/legal/cookie">Info Cookie
                    </router-link>
            </div>
      </cookie-law>
    <v-content style="margin-bottom:150px">
        <header-p></header-p>
        <section style="margin-top:30px">
            <v-layout row lg4 md10 sd12 xs12 align-center justify-center>
                <v-container>
                    <header id="top" style="margin:auto;max-width:900px">
                        <h1 style="font-size:40px;">END USER LICENSE AGREEMENT - LICENZA D'USO</h1>

                        <h4> <b style="color:#666">QuickBe:</b> Il software soggetto</h4>
                        <h4> <b style="color:#666">Dew Studio:</b> Dew Studio </h4>
                        <h4> <b style="color:#666">Utente/Utilizzatore/Cliente:</b> L’acquirente del servizio QuickBe</h4>
                        <h4> <b style="color:#666">Siti:</b> quickbe.app/plaza.quickbe.app</h4>
                        <h4> <b style="color:#666">DLC:</b> Pacchetti aggiuntivi, possono essere sia free che con un costo</h4>
                        <h4> <b style="color:#666">Status:</b> Stato dei dati su Quickbe</h4>

                        <p>Per riferimento alle condizioni d'uso per l'affiliazione o i buoni sconto vai qui: <router-link class="a" to="/legal/affil">condizioni d'uso affiliazioni</router-link>
                        
                        <h1 style="font-size:30px">1. CONDIZIONI D’USO </h1>
                        <h2>1.1 Licenza</h2>
                        <p>QuickBe è un software concesso in licenza da parte di Dew Studio, basato sull’omonimo servizio. Il software è rappresentato dall’utilizzo del servizio attraverso il portale web di quickbe.app e dall'utilizzo delle app. QuickBe quindi è e rimarrà proprietà di Dew Studio. </p>

                        <h2>1.2 Numero licenze</h2>
                        <p>Una licenza QuickBe è valida esclusivamente solo per un unico negozio (singola sede commerciale). Nel caso di più negozi è possibile acquistare comunque altre licenze EX-NOVO a singolo titolare. Quindi, anche se il titolare risulterà lo stesso gli account di gestione saranno diversi.</p>

                        <h2>1.3 Uso improprio</h2>
                        <p>QuickBe è un software finalizzato alla gestione automatizzata delle prenotazioni. Nel caso di utilizzo in maniera diversa (es. agenda personale o altro) non se ne garantisce il corretto funzionamento. </p>

                        <h2>1.4 Abuso</h2>
                        <p>QuickBe è concesso in licenza per singolo negozio, quindi ne è vietato l’uso condiviso con altri negozi (con negozio si intende una singola sede commerciale). Nel caso risultino violazioni dell’EULA, Dew Studio si riserva il diritto di interrompere il servizio senza effettuare alcun rimborso.</p>

                        <h1 style="font-size:30px;">2. CONDIZIONI ABBONAMENTO</h1>

                        <p>Tipi abbonamento</p>
                        <ul>
                            <li>Silver</li>
                            <li>Platinum</li>
                        </ul>

                        <h2>2.1 Differenza tra i servizi</h2>
                        <h3>2.1.2 Silver</h3>
                        <p>Il servizio <b>silver</b> permette un sistema di abbonamento flessibile con rate:</p>
                        <ul>
                            <li>Annuali</li>
                            <li>Semestrali</li>
                            <li>Mensili</li>
                        </ul>
                        <p>E presenta le caratteristiche:</p>
                         <ul>
                            <li>Numero massimo di prenotazioni: <b>Illimitato</b></li>
                            <li>Numero massimo di dipendenti: <b>10</b></li>
                            <li>Numero massimo di giorni della settimana prenotabili: <b>2</b></li>
                            <li>Accesso completo alle DLC FREE</li>
                            <li>Sito gratuito su QuickBe Plaza</li>
                            <li>Supporto tramite e-mail e telefonico a massimo: <b>3</b> giorni lavorativi</li>
                        </ul>
                        <br/>
                        <br/>
                        <p>Il servizio <b>silver</b> offre l’intero pacchetto di funzionalità base di QuickBe (quindi comprende le DLC FREE ma <b>non</b> quelle a pagamento).</p>
                        <h4>Caratteristiche piano SILVER</h4>

                        <h3>2.1.3 PLATINUM</h3>
                            <p>Il servizio <b>platinum</b> offre l’intero pacchetto di funzionalità base di QuickBe, <b>comprese</b> le DLC FREE ed a pagamento.</p>
                            <p>Inoltre, il servizio <b>platinum</b> offre anche l’app per le piattaforme IOS ed Android, personalizzata con i colori e loghi del cliente (sono comprese eventuali modifiche leggere della UI).</p>
                            <p>Il cliente quindi avrà visibilità sia sulla piattaforma QuickBe tramite l’app, sia tramite la piattaforma web QuickBe Plaza e sia tramite la sua app personalizzata.</p>
                            <p>Infatti presenta le caratteristiche:</p>
                         <ul>
                            <li>Numero massimo di prenotazioni: <b>Illimitato</b></li>
                            <li>Numero massimo di dipendenti: <b>10</b></li>
                            <li>Numero massimo di giorni della settimana prenotabili: <b>2</b></li>
                            <li>Accesso completo a tutte le DLC</li>
                            <li>App personalizzata con il tuo nome e i tuoi loghi</li>
                            <li>Gestione gratuita delle app store</li>
                            <li>Sito gratuito su QuickBe Plaza</li>
                            <li>Supporto tramite e-mail e telefonico a massimo: <b>1</b> giorni lavorativi</li>
                        </ul>
                        <br/>

                            <h1 style="font-size:30px;">3. DURATA</h1>
                            <h3>3.1 ABBONAMENTI</h3>
                            <h4>3.1.1 Free</h4>
                            <p>L’abbonamento <b>free</b> non ha scadenza, previa la richiesta esplicita scissione dello stesso.</p>

                            <h4>3.1.2 Silver</h4>
                            <p>L’abbonamento <b>silver</b> ha la durata relativa alla soluzione di pagamento scelta (mensile, semestrale, annuale). Nel caso di rescissione anticipata alla scadenza da parte dell’utente, quest’ultimo rinuncia al diritto di rimborso da parte di Dew Studio per il tempo rimanente.</p>

                            <h4>3.1.3 Platinum</h4>
                            <p>L’abbonamento <b>platinum</b> ha la durata di un anno. Il cliente sarà tenuto comunque a pagare l'intero anno qualora volesse interromperlo. Inoltre il cliente rinuncia al diritto di rimborso da parte di Dew Studio per il tempo rimanente</p>

                            <h3>3.4 CADENZA</h3>
                            <p>La cadenza dell’abbonamento (escluso quello FREE) è equivalente alla fine del tipo d’abbonamento scelto in fase d’acquisto. Inoltre, quest’ultima è giornaliera (sia nel caso mensile, sia nel caso semestrale, sia nel caso annuale), ossia un abbonamento avviato il 16 marzo 2018 scadrà il 16 marzo 2019. Tutto ciò in modo da garantire la massima trasparenza per quanto riguarda la durata.</p>

                            <h3>3.5 SCADENZA</h3>
                            <p>Il sistema d’accesso al cliente verrà bloccato il giorno successivo alla scadenza, ma tutti i suoi dati saranno preservati, a meno di esplicita richiesta di eliminazione. Nel caso il cliente rinnovi l’abbonamento quindi, a meno che non sia stata richiesta esplicitamente la cancellazione, il cliente riprenderà il suo status precedente e potrà continuare ad usufruire del servizio per la nuova durata a partire dal giorno della nuova sottoscrizione.</p>
                            <h3>3.6 RINNOVO</h3>
                            <p>Il sistema non prevede una funzione di rinnovo automatico. Previa comunicazione di scadenza (sia da pannello che per email), il cliente è tenuto ad effettuare la registrazione del pagamento tramite bonifico alle coordinate indicate nell'apposita sezione. Una volta registrato il pagamento e l'accredito, verrà effettuato il rinnovo. </p>

                            <h1 style="font-size:30px;">4. RESPONSABILITÀ E AGGIORNAMENTO</h1>
                            <h3>4.1 Aggiornamenti</h3>
                            <p>QuickBe è in continuo aggiornamento, sia per quanto riguarda patch di sicurezza (per garantire la massima sicurezza ai dati dell’utente) sia per quanto riguarda le funzionalità, arricchendo quindi il pacchetto in maniera trasparente per il cliente.
                                Comunque, non si garantisce il perpetuar di condizione per la fruizione di funzioni specifiche, quanto è garantito il requisito funzionale di queste ultime.</p>
                            <h3>4.2 Responsabilità</h3>
                            <p>Dew Studio non si ritiene responsabile di eventuali danni fatti a persone o cose mediante l’utilizzo del software. Il cliente quindi rinuncia al diritto di rivalersi su Dew Studio nel caso di procedimenti penali, giudiziari e civili.</p>
                            <h3>4.3 Modifiche unilaterali EULA e Trattamento Dati</h3>
                            <p>Dew Studio si riserva il diritto di effettuare, previa comunicazione ai propri clienti, modifiche all'E.U.L.A. e ai termini e condizioni d'uso dei dati (sia per utenza app che per esercenti).</p>
                            <h3>4.4 Modifiche unilaterali abbonamenti</h3>
                            <p>Dew Studio si riserva il diritto di effettuare, previa comunicazione ai propri clienti, modifiche agli abbonamenti. Le modifiche possono coinvolgere i costi o le limitazioni (vedi piano FREE). Comunque, nel caso di modifiche, l'abbonamento attivo sarà valido fino alla scadenza alle condizioni precedentemente concordate (tranne al piano free dove verranno applicate il mese solare successivo).</p>

                            <br/>
                            <br/>
                            <p>Per informazioni relative al trattamento dati, effettuato secondo la normativa 679/2016 G.D.P.R., vai <router-link class="a" to="/legal/tec">qui</router-link>.</p>
                    </header>
                </v-container>
            </v-layout>
            <v-layout column>
                <v-flex xs12 sm4 class="my-3">
                    <div class="text-xs-center">

                        <v-container>
                            <v-btn class="q-orange" @click="$router.push({path:'/'})">{{getString('Torna a ')}}{{appName}}</v-btn>
                        </v-container>
                    </div>
                </v-flex>
            </v-layout>
        </section>
    </v-content>
    <v-footer dark height="auto" class=".footer">
        <v-card class="flex" flat tile>
            <v-card-title class="q-orange-bk">
                <strong class="subheading">{{getString("Seguici sui social!")}}</strong>
                <v-spacer></v-spacer>
                <v-btn v-for="icon in icons" :key="icon.ic" class="mx-3" dark icon @click="navigate(icon.url)">
                    <v-icon size="24px">{{ icon.ic }}</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="grey darken-3 justify-center" style="text-align:center">
                &copy; 2018 - &copy;{{(new Date()).getFullYear()}} — &nbsp;<strong>Dew Studio </strong> &nbsp; — &nbsp;
                <a href="https://plaza.quickbe.app">{{getString('QuickBe Plaza')}}</a>&nbsp; — &nbsp;
                <router-link to="/legal/tec">{{getString('Trattamento dati')}}</router-link>&nbsp; — &nbsp;
                <router-link to="/legal/cookie">{{('Cookie Policy')}}</router-link>&nbsp; — &nbsp;
                <router-link to="/legal/eula">{{('Termini e condizioni')}}</router-link>&nbsp; — &nbsp;
                <router-link to="/admin/login">{{getString('Portale')}}</router-link>
            </v-card-text>
        </v-card>
    </v-footer>
</v-app>
</template>

<script>
import HeaderP from './Header'
import CookieLaw from "vue-cookie-law";
export default {
  name: 'LegalEULA',
  components: {
        HeaderP,
        CookieLaw
    },
  data: () => {
    return {
      icons: [
        {
          ic: 'fab fa-facebook',
          url: 'https://www.facebook.com/QuickBeApp/'
        },
        {
          ic: 'fab fa-instagram',
          url: 'https://www.instagram.com/quickbeapp/'
        }
      ],
      appName: 'QuickBe'
    }
  },
  methods: {
    navigate: function(url) {
      window.open(url)
    },
    getString: function(key) {
      let page = this.$store.state.currentTranslator.getString(key)
      return page
    }
  }
}
</script>

<style scoped>
h2,
h3,
h4 {
  color: #d5725b;
}

.table {
  border: solid thin #999;
}

.table td {
  border: solid thin #999;
  padding: 5px 10px;
  margin: 0;
}

.table tr {
  border-right: none;
}
</style>



// WEBPACK FOOTER //
// src/components/frontend/LegalEULA.vue